'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

exports.firestoreDataSelector = firestoreDataSelector;
exports.firestoreOrderedSelector = firestoreOrderedSelector;

var _query = require('./utils/query');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function firestoreDataSelector(queryConfig) {
  return function (state, getPath) {
    var queryName = (0, _query.getQueryName)(queryConfig, { onlySubcollections: true });
    if (!getPath) {
      return state.firestore.data[queryName];
    }
    return (0, _get3.default)(state.firestore.data[queryName], getPath);
  };
}

function firestoreOrderedSelector(queryConfig) {
  return function (state, getPath) {
    var queryName = (0, _query.getQueryName)(queryConfig);
    if (!getPath) {
      return state.firestore.ordered[queryName];
    }
    return (0, _get3.default)(state.firestore.ordered[queryName], getPath);
  };
}